import Vue from 'vue'
import service from '../services/warehouseExpensePalletsService.js'

export function useExpensePallets() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getExpenses(params = {}) {
    state.loading = true
    try {
      const response = await service.getExpenses(params)
      state.items = response.current_page === 1
        ? [...response.data]
        : [...state.items, ...response.data]
      state.currentPage = response.current_page
      state.lastPage = response.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function approveExpense(payload) {
    state.loading = true
    try {
      const response = await service.approveExpense(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function deleteExpense(payload) {
    state.loading = true
    try {
      const response = await service.deleteExpense(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getFiles(payload) {
    state.loading = true
    try {
      const response = await service.getFiles(payload)
      if (!response || typeof response !== "object") {
        return { success: false, error: "Respuesta inválida del servidor" }
      }
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getExpense(payload) {
    state.loading = true
    try {
      const response = await service.getExpense(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateExpense(payload) {
    state.loading = true
    try {
      const response = await service.updateExpense(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getPallets() {
    state.loading = true
    try {
      const response = await service.getPallets()
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updatePallets(payload) {
    state.loading = true
    try {
      const response = await service.updatePallets(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getExpenses, getExpense, approveExpense, deleteExpense, getFiles, updateExpense, getPallets,updatePallets }
}
